import React from "react";

import { Card, CardContent, Typography, List } from "@mui/material";

import { WeblinkListItem } from "./WeblinkListItem";

export const CatchmentCard = ({ catchmentFeature }) => {
  return (
    <Card>
      <CardContent>
        <Typography component="div" variant="h5">
          {catchmentFeature.name}
        </Typography>
        <List>
          <WeblinkListItem weblink={catchmentFeature.website} />
        </List>
      </CardContent>
    </Card>
  );
};
